import React from 'react';

export const AgilyticsStateContext = React.createContext();
export const AgilyticsDispatchContext = React.createContext();

const INITIAL_STATE = {
  cloudId: window.localStorage.getItem('agilytics/cloudId'),
  cloudIds: [],
  projects: [],
  showCookiePreferences: false,
  complianceOptIn: null,
};

function reducer(state, action) {
  switch (action.type) {
    case 'updateAccessToken': {
      return { ...state, accessToken: action.accessToken };
    }
    case 'updateCloudIds': {
      return { ...state, cloudIds: action.cloudIds };
    }
    case 'selectInstance': {
      window.localStorage.setItem('agilytics/cloudId', action.cloudId);
      return { ...state, cloudId: action.cloudId };
    }
    case 'updateProjects': {
      return { ...state, projects: action.projects };
    }
    case 'logout': {
      return INITIAL_STATE;
    }
    case 'updateComplianceOptIn': {
      return { ...state, complianceOptIn: action.complianceOptIn };
    }
    case 'showCookiePreferences': {
      return { ...state, showCookiePreferences: true };
    }
    case 'hideCookiePreferences': {
      return { ...state, showCookiePreferences: false };
    }
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
}

export function AgilyticsProvider({ children, initialState = {} }) {
  const [state, dispatch] = React.useReducer(reducer, { ...INITIAL_STATE, ...initialState });
  return (
    <AgilyticsStateContext.Provider value={state}>
      <AgilyticsDispatchContext.Provider value={dispatch}>{children}</AgilyticsDispatchContext.Provider>
    </AgilyticsStateContext.Provider>
  );
}

export function useAgilyticsState() {
  const context = React.useContext(AgilyticsStateContext);
  if (context === undefined) {
    throw new Error('useAgilyticsState must be used within a AgilyticsProvider');
  }
  return context;
}

export function useAgilyticsDispatch() {
  const context = React.useContext(AgilyticsDispatchContext);
  if (context === undefined) {
    throw new Error('useAgilyticsDispatch must be used within a AgilyticsProvider');
  }
  return context;
}
